import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import IndustriesHero from "./components/IndustriesHero";
import IndustryCards from "./components/IndustryCards";
import IndustryValue from "./components/IndustryValue";
import IndustriesCTA from "./components/IndustriesCTA";

export default function IndustriesPage() {
  return (
    <div className="bg-[#09090B] min-h-screen">
      <link
        href="https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@400;500;600;700;800&family=Inter:wght@400;500;600&display=swap"
        rel="stylesheet"
      />
      <Navbar />
      <main>
        <IndustriesHero />
        <IndustryCards />
        <IndustryValue />
        <IndustriesCTA />
      </main>
      <Footer />
    </div>
  );
}
